import { inject } from '@angular/core';
import { Router } from '@angular/router';

export class RouterHelpers {
  static isPathPartOfRout() {
    const router = inject(Router);
    return (pathToSearch: string): string => router.url.split('/').find(path => path === pathToSearch);
  }
}
